import { render, staticRenderFns } from "./BindMobile.vue?vue&type=template&id=56c4071e&scoped=true&"
import script from "./BindMobile.vue?vue&type=script&lang=js&"
export * from "./BindMobile.vue?vue&type=script&lang=js&"
import style0 from "./BindMobile.vue?vue&type=style&index=0&id=56c4071e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c4071e",
  null
  
)

export default component.exports